import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/34.mp3"
export default function P1() {
    return (
        <MainLayout
            title="W stronę Warty"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p61,
            }}
            content={
                <div>
                    <p>
                        W rzece pluskają się gęsi, a niektóre odpoczywają na wysepkach. Stoicki spokój ptaków udziela się i tobie.
                    </p>
                    <ul>
                        <li>
                            Spokojnie, ha ha, myśmy na tę wodę czekali, jak co roku – uśmiecha się Emil, wychodząc z domu. – Ryby będą, trawa urośnie, a i tak każdy ma przy chałupie koryto, łódkę znaczy, i jeśli nie pojedzie wozem, to przepłynie… To znaczy prawie każdy, bo ja akurat swoją pożyczyłem sąsiadom…
                        </li>
                    </ul>
                </div>
            }
        />

    );
}